import React, { Suspense } from "react";
import { Route, Switch, Redirect, useLocation } from "react-router-dom";
import Login from "./common/login";
import LoginSinWA from "./common/loginSinWA";
import Acepta from "./common/acepta";
import politicaPrivacidad from "./common/politicaPrivacidad";
import condiciones from "./common/condiciones";
import "./App.css";

function App() {
  const { pathname } = useLocation();
  return (
    <Suspense fallback={null}>
      <Switch>
        <Redirect from="/:url*(/+)" to={pathname.slice(0, -1)} />
        <Route path="/:id/" component={Login} exact />
        <Route path="/:id/acceso" component={LoginSinWA} exact />
        <Route path="/:id/acepta" component={Acepta} exact />
        <Route path="/:id/politica" component={politicaPrivacidad} exact />
        <Route path="/:id/condiciones" component={condiciones} exact />
      </Switch>
    </Suspense>
  );
}

export default App;
